import React from 'react';
import ChatProfileModalLayer from './ChatProfileModalLayer';

export default function MemberListProfileLayer({
  profileTarget,
  buildArtistProfile,
  buildAdminProfile,
  onClose,
  variant = 'admin',
  allowArtistLink,
}) {
  if (!profileTarget) return null;

  const isArtist = profileTarget.type === 'artist';
  const artistProfile = isArtist ? buildArtistProfile(profileTarget.payload) : null;
  const adminProfile = !isArtist ? buildAdminProfile(profileTarget.payload) : null;

  return (
    <ChatProfileModalLayer
      artistProfile={artistProfile}
      adminProfile={adminProfile}
      onClose={onClose}
      variant={variant}
      allowArtistLink={allowArtistLink}
    />
  );
}
